import { Checkbox, CheckboxProps, FormControlLabel } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';
import { CheckboxIcon } from '../icons';

interface SystemCheckboxProps extends CheckboxProps {
    label: string;
    handleChange: (checked: boolean) => void;
}

export const SystemCheckbox: React.FC<SystemCheckboxProps> = (props) => {
    const { label, checked, handleChange } = props

    const onChange = (_event: React.SyntheticEvent, isChecked: boolean) => {
        handleChange(isChecked);
    }

    return (
        <FormControlLabel
            control={(
                <Checkbox
                    checked={checked}
                    onChange={onChange}
                    icon={<CheckboxIcon isChecked={false} />}
                    checkedIcon={<CheckboxIcon isChecked={true} />}
                />
            )}
            label={label}
        />
    )
}

interface ControlledSystemCheckboxProps extends Omit<SystemCheckboxProps, "checked" | "handleChange"> {
    name: string;
}

export const ControlledSystemCheckbox: React.FC<ControlledSystemCheckboxProps> = (props) => {
    const { name, ...restOfProps } = props;
    const { control } = useFormContext();

    return (
        <Controller
            name={name}
            control={control}
            render={({ field }) => (
                <SystemCheckbox
                    {...field}
                    {...restOfProps}
                    checked={field.value}
                    handleChange={(checked) => field.onChange(checked)}
                />
            )}
        />
    )
}